const SocialMediaIcons = () => {
  return (
    <ul className="social__icons">
      <li>
        <a
          href="https://www.fhnw.ch"
          target="_blank"
          title="Folgen Sie uns auf Instagram"
          className="icon__instagram--sm"
        />
      </li>
      <li>
        <a
          href="https://facebook.com/fhnw.ch"
          target="_blank"
          title="folgen Sie uns auf Facebook"
          className="icon__facebook--sm"
        />
      </li>
      <li>
        <a
          href="https://bsky.app/profile/fhnw.ch"
          target="_blank"
          title="folgen Sie uns auf Bluesky"
          className="icon__bluesky--sm"
        />
      </li>
      <li>
        <a
          href="https://www.xing.com/companies/fachhochschulenordwestschweiz/"
          target="_blank"
          title="folgen Sie uns auf Xing"
          className="icon__xing--sm"
        />
      </li>
      <li>
        <a
          href="https://www.linkedin.com/school/fachhochschule-nordwestschweiz-fhnw/"
          target="_blank"
          title="folgen Sie uns auf LinkedIn"
          className="icon__linkedin--sm"
        />
      </li>
      <li>
        <a
          href="https://www.fhnw.ch"
          target="_blank"
          title="folgen Sie uns auf YouTube"
          className="icon__youtube--sm"
        />
      </li>
      <li>
        <a
          href="https://www.fhnw.ch"
          target="_blank"
          title="folgen Sie uns auf Vimeo"
          className="icon__vimeo--sm"
        />
      </li>
      <li>
        <a
          href="https://www.fhnw.ch"
          target="_blank"
          title="folgen Sie uns auf Flickr"
          className="icon__flickr--sm"
        />
      </li>
      <li>
        <a
          href="https://www.fhnw.ch"
          target="_blank"
          title="folgen Sie uns auf Issuu"
          className="icon__issuu--sm"
        />
      </li>
    </ul>
  );
};

export default SocialMediaIcons;
